import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from 'src/common/utils/api';
import { useFileUploadMutation } from 'src/data-capture/hooks/useFileUploadMutation';
import { Logger } from 'src/utils/Logger';
import { CompanyAppendix } from '../types';

export const useCreateCompanyAppendix = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { uploadToFileStorage } = useFileUploadMutation();
  const queryClient = useQueryClient();

  const createCompanyAppendix = async (file: File) => {
    try {
      setIsLoading(true);
      await uploadToFileStorage({ file, subfolder: 'appendices' });
      await api.post<CompanyAppendix>('company-appendices', {
        file: {
          fileName: file.name,
          fileSize: file.size,
          fileType: file.type,
          subfolder: 'appendices',
        },
      });
      queryClient.invalidateQueries({ queryKey: ['company-appendices'] });
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      Logger.error('Failed to upload company appendix', e);
      throw e;
    }
  };

  return {
    createCompanyAppendix,
    isLoading,
  };
};
